export enum MatchType {
  ExactMatch = 1,
  PartialMatch = 2,
  Recommendation = 3,
}

export interface CanonicalSkillAutoCompleteResultItem {
  skillId: string;
  code: string;
  canonicalName: string;
  name: string;
  score: number;
  matchType: MatchType;
}

export interface SkillAutoCompleteRequest {
  query: string;
  skillBaseType: number;
  selectedCanonicalSkillIds: string[];
  selectedCustomSkills: string[];
}

export interface SkillAutoCompleteResult {
  queryResultItems: CanonicalSkillAutoCompleteResultItem[];
  suggestedItems: CanonicalSkillAutoCompleteResultItem[];
}
export interface SkillListRequest {
  codes: string[];
}

export interface SkillListItem {
  skillId: string;
  code: string;
  canonicalName: string;
  name: string;
}

export interface SkillListResult {
  items: SkillListItem[];
}

export interface JobseekerSkillViewModel {
  canonicalSkillId: string;
  code?: string;
  name: string;
  isCustom: boolean;
  userProvidedText?: string;
}

export interface AnnouncementSkillViewModel {
  canonicalSkillId: string;
  name: string | null;
  isCustom: boolean;
  source: number;
  userProvidedText?: string;
}

export interface JobseekerSkillItem {
  name: string;
  userProvidedText: string;
  index: number;
  source: number;
  skillId: string;
}

export interface AnnouncementSkillItem {
  name: string;
  userProvidedText: string;
  index: number;
  source: number;
  skillId: string;
}

export enum SkillBaseTypeEnum {
  Hard = 1,
  Soft = 2
}

export enum SkillSource {
  Manual = 1,
  Parsed = 2
}
